export const SET_ACCOUNT_ASSOCIATION_PENDING_REQUEST = 'setAccountAssociationPendingRequest'
export const SET_ACCOUNT_ASSOCIATION_TYPES = 'setAccountAssociationTypes'
export const SET_USER_ACCOUNT_ASSOCIATIONS = 'setUserAccountAssociations'
